/**
 * Racine de l’application : routeur + amorçage de session + synchronisation du document.
 *
 * Aucun fournisseur i18n explicite : `initReactI18next` a déjà installé l’instance dans
 * `src/i18n` (importé par `main.tsx`). Le changement de langue re-rend donc tous les composants
 * qui utilisent `useTranslation`, sans rechargement.
 */
import { BrowserRouter } from 'react-router-dom';

import { AmorcageSession } from './amorcage-session';
import { routes } from './routes';
import { SynchronisationDocument } from './synchronisation-document';
import { BandeauCookies } from '../ui/BandeauCookies';

export function App() {
  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <AmorcageSession />
      <SynchronisationDocument />
      {routes}
      <BandeauCookies />
    </BrowserRouter>
  );
}
